import { Skeleton } from "@mui/material";
import { GameDisplayHeight } from "./Constants";

export default function GamesSkeleton({ num = 1 }: { num?: number }) {
  const arr = Array.from({ length: num }, (x, i) => i);
  return (
    <>
      {arr.map((n) => (
        <Skeleton
          variant="rectangular"
          key={`gameSkel:${n}`}
          className="game-display--container"
          height={GameDisplayHeight}
          sx={{ border: "1px solid transparent" }}
        />
      ))}
    </>
  );
}
